import React, { createContext, useContext, useMemo } from 'react';

const ModalStackContext = createContext(0);

const Z_BASE = 10000;
const Z_STEP = 10;

export function ModalStackProvider({ children }) {
  return (
    <ModalStackContext.Provider value={0}>
      {children}
    </ModalStackContext.Provider>
  );
}

export function useModalStack() {
  const depth = useContext(ModalStackContext);
  const zBase = Z_BASE + depth * Z_STEP;

  const zIndexes = useMemo(() => ({
    modal: zBase,
    backdrop: zBase - 1,
    paper: zBase + 1,
    popover: zBase + 2,
    menu: zBase + 3,
  }), [zBase]);

  return { depth, zIndexes, nextDepth: depth + 1 };
}

export { ModalStackContext };
